/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import PostContentTitle from 'app/components/common/PostContentTitle.jsx';
import AccordionControl from 'app/components/common/AccordionControl.jsx';
import { Breakpoint } from 'react-socks';

class PostContentSummary extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            summaryString: '',
            isSummaryShown: false
        };

        this.prepareSummaryString = this.prepareSummaryString.bind(this);
        this.toggleSummary = this.toggleSummary.bind(this);

    }

    componentDidMount() {

        let constants = this.props.app.config.constants;

        if (this.props.input.hasOwnProperty('subtype') && + this.props.input.subtype === constants.INPUT_SUBTYPE_PINTEREST) {
            this.setState({
                summaryString: ''
            });
        } else {
            this.prepareSummaryString();
        }
    }

    prepareSummaryString() {

        let summary,
            summaryString;
        let item = this.props.item;

        if (item.item.body === item.item.title) {
            summaryString = '';
        } else {
            /**
       * We can't assume the item body data for display is to our liking,
       * or that it exists, so check for it, then, if it's there,
       * create a DOM element, strip whitespace from the beginning of
       * the source data and assign it to the DOM element.
       *
       * @type {object}
       */
            summary = document.createElement('div');
            summary.innerHTML = item.item
                ? item.item.body.replace(/&nbsp;/, '')
                : '';

            /**
       * Trim the innerHTML and assign the now prepared content
       * to summaryString
       *
       * @type {string}
       */
            if (summary.textContent) {
                summaryString = summary.textContent.trim();
            } else if (summary.innerText) {
                summaryString = summary.innerText.trim();
            } else {
                summaryString = '';
            }
        }

        this.setState({
            summaryString
        });

    }

    toggleSummary(e) {

        this.setState({
            isSummaryShown: !this.state.isSummaryShown
        });

    }

    render() {
        let mobileSummary = this.state.summaryString,
            mobileDisclosure = (
                <AccordionControl accordionOpen={this.state.isSummaryShown}/>
            );

        if (this.state.summaryString.length > 40) {
            if (!this.state.isSummaryShown) {
                mobileSummary = this.state.summaryString.substring(0, 39) + "...";
            }
        }

        return (
            <div className="item-summary queue-item-summary">
                <PostContentTitle item={this.props.item}/>
                <Breakpoint desktop only>
                    <div className="post-preview-body ellipsis">
                        {this.state.summaryString}
                    </div>
                </Breakpoint>
                <Breakpoint mobile only>
                    <div className="mobile-summary" onClick={this.toggleSummary} role="button" aria-label="show summary">
                        {mobileDisclosure}
                        <div className="mobile-summary-content">
                            {mobileSummary}
                        </div>
                    </div>
                </Breakpoint>
            </div>
        );

    }

};

PostContentSummary.propTypes = {
    item: PropTypes.object,
    input: PropTypes.object
};

PostContentSummary.defaultProps = {
    item: {},
    input: {}
};

export default PostContentSummary;
